@if (component) {
  <div class="flex p-t-8 p-b-8 wrap row-accordion-component"
    [class.flex-column]="isAccordion">
    <!-- main sections -->
    @for (column of component.columns; track $index; let i = $index) {
      <div [ngClass]="'flex-span-' + column.size"
        >
        <!-- header -->
        <h6 class="fs-6 fw-bold"
          [ngClass]="isAccordion ? 'b-b b-col-w p-b' : ''"
          zippyClass="is-open"
          [zippyOpen]="['rowAccordion' + uid , i]"
          *iCms="'heading' of column">
        </h6>
        <!-- content -->
        <div [ngClass]="isAccordion ? 'hide-up-container' : ''">
          <div class="p-t"
            [ngClass]="isAccordion ? 'hide-up ng-hide ng-hide-animate p-t-2 p-b-2 b-b' : ''"
            [zippy]="['rowAccordion' + uid, i]"
            [zippyOff]="!isAccordion"
            [zippyAuto]="true">
            <icms-outlet [components]="column.components">
            </icms-outlet>
          </div>
        </div>
      </div>
    }
  </div>
}
